export default __webpack_public_path__ + "static/media/rg.4369e340.png";